<template>
  <Icon>
    <svg slot="svg" width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M21.3125,9.6875 L9.6875,9.6875 C9.28571094,9.6875 8.9609375,10.013 8.9609375,10.4140625 C8.9609375,10.8158516 9.28571094,11.140625 9.6875,11.140625 L21.3125,11.140625 C21.7142891,11.140625 22.0390625,10.8158516 22.0390625,10.4140625 C22.0390625,10.013 21.7142891,9.6875 21.3125,9.6875 Z M25.671875,24.21875 C25.671875,25.0172422 24.8828281,25.6805938 24.0857891,25.6805938 L6.76235937,25.6805938 C5.96532031,25.6805938 5.31867969,25.0339531 5.31867969,24.2354609 L5.31867969,6.90113281 C5.31867969,6.10264062 5.98348437,5.328125 6.78125,5.328125 L24.21875,5.328125 C25.0165156,5.328125 25.671875,5.98348437 25.671875,6.78125 L25.671875,24.21875 Z M24.21875,3.875 L6.78125,3.875 C5.18717187,3.875 3.875,5.30560156 3.875,6.90113281 L3.875,24.2354609 C3.875,25.8317188 5.16755469,27.125 6.76235937,27.125 L24.0857891,27.125 C25.6805938,27.125 27.125,25.8142813 27.125,24.21875 L27.125,6.78125 C27.125,5.18571875 25.8128281,3.875 24.21875,3.875 Z M21.3125,18.40625 L9.6875,18.40625 C9.28571094,18.40625 8.9609375,18.73175 8.9609375,19.1328125 C8.9609375,19.5346016 9.28571094,19.859375 9.6875,19.859375 L21.3125,19.859375 C21.7142891,19.859375 22.0390625,19.5346016 22.0390625,19.1328125 C22.0390625,18.73175 21.7142891,18.40625 21.3125,18.40625 Z M21.3125,14.046875 L9.6875,14.046875 C9.28571094,14.046875 8.9609375,14.372375 8.9609375,14.7734375 C8.9609375,15.1752266 9.28571094,15.5 9.6875,15.5 L21.3125,15.5 C21.7142891,15.5 22.0390625,15.1752266 22.0390625,14.7734375 C22.0390625,14.372375 21.7142891,14.046875 21.3125,14.046875 Z" id="path-1-note"></path>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="comps/wyjatek-item" transform="translate(-1139.000000, -22.000000)">
          <g id="icons/note">
            <g transform="translate(1136.000000, 19.000000)">
              <rect id="Bounding-Box" x="0" y="0" width="31" height="31"></rect>
              <mask id="mask-2-note" fill="white">
                <use xlink:href="#path-1-note"></use>
              </mask>
              <use id="Shape" fill="#000000" fill-rule="evenodd" xlink:href="#path-1-note"></use>
              <g id="Mixin/Fill/Secondary" mask="url(#mask-2-note)" fill="#002940" fill-rule="evenodd">
                <rect id="Box" x="0" y="0" width="31.0400517" height="30.8012821"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsNoteIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-note-icon.vue